export enum AppModules {
  DASHBOARD = "DASHBOARD",
  TICKETS = "TICKETS",
  CHANNELS = "CHANNELS",
  SUPPORTS = "SUPPORTS",
  REVIEWS = "REVIEWS",
  HELP = "HELP",
  REPORTS = "REPORTS",
  DYNAMIC_REPORT = "DYNAMIC_REPORT",
  PROFILE = "PROFILE",
  PRE_REGISTER = "PRE_REGISTER",
  INVOICING = "INVOICING"
}
